<template>
  <footer class="site-footer">
    <div class="footer-container">
      <!-- 主要内容区域 -->
      <div class="footer-main">
        <div class="footer-grid">
          <!-- 公司信息 -->
          <div class="footer-section">
            <div class="footer-logo">
              <div class="logo-icon">
                <img src="@/assets/logo.png" alt="山东文达检测" class="logo-image" />
              </div>
              <div class="logo-text">
                <h3>山东文达检测</h3>
                <p>专业检验检测服务</p>
              </div>
            </div>
            <p class="company-desc">
              致力于为客户提供专业、准确、高效的检验检测服务，
              以科技创新为驱动，以质量为生命，为各行业发展保驾护航。
            </p>
            <!-- <div class="social-links">
              <a href="#" class="social-link" title="微信">
                <el-icon><ChatDotRound /></el-icon>
              </a>
              <a href="#" class="social-link" title="微博">
                <el-icon><Share /></el-icon>
              </a>
              <a href="#" class="social-link" title="邮箱">
                <el-icon><Message /></el-icon>
              </a>
              <a href="#" class="social-link" title="电话">
                <el-icon><Phone /></el-icon>
              </a>
            </div> -->
          </div>

          <!-- 快速导航 -->
          <div class="footer-section">
            <h4 class="section-title">快速导航</h4>
            <ul class="footer-links">
              <li><router-link to="/">网站首页</router-link></li>
              <li><router-link to="/about">关于我们</router-link></li>
              <li><router-link to="/news">新闻资讯</router-link></li>
              <li><router-link to="/services">我们的服务</router-link></li>
              <li><router-link to="/testing-center">报告查真伪</router-link></li>
            </ul>
          </div>

          <!-- 服务项目 -->
          <div class="footer-section">
            <h4 class="section-title">服务项目</h4>
            <ul class="footer-links">
              <li><router-link to="/services">食品检测</router-link></li>
              <li><router-link to="/services">环境监测</router-link></li>
              <li><router-link to="/services">材料检测</router-link></li>
              <li><router-link to="/services">化学分析</router-link></li>
              <li><router-link to="/services">质量认证</router-link></li>
            </ul>
          </div>

          <!-- 联系信息 -->
          <div class="footer-section">
            <h4 class="section-title">联系我们</h4>
            <div class="contact-info">
              <div class="contact-item">
                <el-icon class="contact-icon"><Location /></el-icon>
                <div class="contact-text">
                  <span class="contact-label">地址：</span>
                  <span>山东省临沂市兰陵县经济开发区赵官庄社区</span>
                </div>
              </div>
              <!-- <div class="contact-item">
                <el-icon class="contact-icon"><Phone /></el-icon>
                <div class="contact-text">
                  <span class="contact-label">电话：</span>
                  <span>400-999-3871</span>
                </div>
              </div> -->
              <div class="contact-item">
                <el-icon class="contact-icon"><Message /></el-icon>
                <div class="contact-text">
                  <span class="contact-label">邮箱：</span>
                  <span>jc_report@yeah.net</span>
                </div>
              </div>
              <div class="contact-item">
                <el-icon class="contact-icon"><Clock /></el-icon>
                <div class="contact-text">
                  <span class="contact-label">工作时间：</span>
                  <span>周一至周五 9:00-18:00</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 底部版权信息 -->
      <!-- <div class="footer-bottom">
        <div class="footer-bottom-content">
          <div class="copyright">
            <p>&copy; 2025 山东文达检测有限公司. 保留所有权利.</p>
          </div>
          <div class="certifications">
            <span>皖ICP备2025101341号-1</span>
          </div>
        </div>
      </div> -->
    </div>
  </footer>
</template>

<script>
import { 
  Document, 
  ChatDotRound, 
  Share, 
  Message, 
  Phone, 
  Location, 
  Clock 
} from '@element-plus/icons-vue'

export default {
  name: 'Footer',
  components: {
    Document,
    ChatDotRound,
    Share,
    Message,
    Phone,
    Location,
    Clock
  }
}
</script>

<style scoped>
.site-footer {
  background: linear-gradient(135deg, #0f1419 0%, #1e3c72 50%, #2a5298 100%);
  color: white;
  margin-top: auto;
}

.footer-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-main {
  padding: 60px 0 40px;
}

.footer-grid {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1.5fr;
  gap: 40px;
}

.footer-section {
  display: flex;
  flex-direction: column;
}

/* 公司信息区域 */
.footer-logo {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.logo-icon {
  width: 45px;
  height: 45px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: white;
  overflow: hidden;
}

.footer-logo .logo-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 10px;
}

.logo-text h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: white;
  line-height: 1.2;
}

.logo-text p {
  margin: 2px 0 0 0;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
}

.company-desc {
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
  margin-bottom: 25px;
  font-size: 14px;
}

.social-links {
  display: flex;
  gap: 12px;
}

.social-link {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.social-link:hover {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(79, 172, 254, 0.4);
}

/* 标题样式 */
.section-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
  color: white;
  position: relative;
  padding-bottom: 10px;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 30px;
  height: 2px;
  background: linear-gradient(90deg, #4facfe, #00f2fe);
}

/* 链接列表 */
.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li {
  margin-bottom: 12px;
}

.footer-links a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  font-size: 14px;
  transition: all 0.3s ease;
  display: inline-block;
}

.footer-links a:hover {
  color: #4facfe;
  transform: translateX(5px);
}

/* 联系信息 */
.contact-info {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.contact-icon {
  color: #4facfe;
  font-size: 16px;
  margin-top: 2px;
  flex-shrink: 0;
}

.contact-text {
  font-size: 14px;
  line-height: 1.5;
}

.contact-label {
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
}

.contact-text span:last-child {
  color: rgba(255, 255, 255, 0.8);
}

/* 底部版权区域 */
.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 25px 0;
}

.footer-bottom-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.copyright p {
  margin: 0;
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
}

.footer-links-bottom {
  display: flex;
  align-items: center;
  gap: 15px;
}

.footer-links-bottom a {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s ease;
}

.footer-links-bottom a:hover {
  color: #4facfe;
}

.separator {
  color: rgba(255, 255, 255, 0.4);
}

.certifications {
  color: rgba(255, 255, 255, 0.6);
  font-size: 13px;
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .footer-grid {
    grid-template-columns: 1fr 1fr;
    gap: 30px;
  }
}

@media (max-width: 768px) {
  .footer-main {
    padding: 40px 0 30px;
  }
  
  .footer-grid {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  
  .footer-bottom-content {
    flex-direction: column;
    text-align: center;
    gap: 15px;
  }
  
  .footer-links-bottom {
    flex-wrap: wrap;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .footer-container {
    padding: 0 15px;
  }
  
  .footer-main {
    padding: 30px 0 20px;
  }
  
  .social-links {
    justify-content: center;
  }
  
  .contact-item {
    flex-direction: column;
    gap: 5px;
    text-align: center;
  }
}
</style>